"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cartesian2dUpdateArg = void 0;
const rc_js_util_1 = require("rc-js-util");
const cartesian2d_transforms_1 = require("./cartesian2d-transforms");
const core_1 = require("@visualization-tools/core");
const cartesian2d_identity_transform_1 = require("../user-transforms/cartesian2d-identity-transform");
/**
 * @public
 * {@inheritDoc ICartesian2dUpdateArg}
 */
class Cartesian2dUpdateArg {
    constructor(ctor) {
        this.userTransformId = -1;
        const range2dFactory = rc_js_util_1.Range2d.getCtor(ctor).factory;
        this.plotRange = range2dFactory.createOneEmpty();
        this.transformedDataRange = range2dFactory.createOneEmpty();
        this.userTransform = new cartesian2d_identity_transform_1.Cartesian2dIdentityTransform();
        this.drawTransforms = new cartesian2d_transforms_1.Cartesian2dTransforms(ctor);
        this.interactionTransforms = new cartesian2d_transforms_1.Cartesian2dTransforms(ctor);
        this.canvasDimensions = core_1.CanvasDimensions.createDefault();
        this.plotDimensionsOBL = core_1.PlotDimensions.createDefault();
        this.plotDimensionsOTL = core_1.PlotDimensions.createDefault();
    }
    update(plot, canvasDims) {
        if (this.userTransformId !== plot.plotRange.userTransform.changeId) {
            plot.plotRange.updateUserTransform(plot.plotRange.userTransform);
            this.userTransformId = plot.plotRange.userTransform.changeId;
        }
        this.userTransform = plot.plotRange.userTransform;
        this.plotRange = plot.plotRange.dataRange;
        this.transformedDataRange = plot.plotRange.transformedDataRange;
        this.plotDimensionsOBL = plot.plotDimensionsOBL;
        this.plotDimensionsOTL = plot.plotDimensionsOTL;
        this.canvasDimensions = canvasDims;
        // drawTransforms is specific to the drawing technology so is updated elsewhere
        this.interactionTransforms.update(this.transformedDataRange, plot.plotDimensionsOBL.cssArea.wholeRange, plot.plotDimensionsOBL.cssArea.interactiveRange);
    }
}
exports.Cartesian2dUpdateArg = Cartesian2dUpdateArg;
//# sourceMappingURL=cartesian2d-update-arg.js.map